import { render, staticRenderFns } from "./UnderContruction.vue?vue&type=template&id=b0c17fea&scoped=true&lang=pug&"
var script = {}
import style0 from "./UnderContruction.vue?vue&type=style&index=0&id=b0c17fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c17fea",
  null
  
)

export default component.exports